const langLinks = document.querySelectorAll('.lang-link');

for (const langLink of langLinks) {
    langLink.addEventListener('click', async function(e) {
        const dataset = langLink.dataset;

        const formData = new FormData();
        formData.append('lang', dataset.lang);

        const response = await fetch('/api/cart', {
            method: 'POST',
            headers: {
                'X-csrf-token': _token
            },
            body: formData,
        });

        if(response.ok) {
            window.location = '/' + dataset.slug;                
        }
    })
}
